import { useEffect } from "react";
import Stack from "@mui/material/Stack";
import { useQuery } from "react-query";
import {
  listCustomerTotalizers,
  listTotalRegistrations,
  listOverviewDDD,
  listOverviewGenre,
  listOverviewRegisterDay,
  listOverviewRegisterMonth,
  listOverviewAge,
} from "../../services/insights";
import { Email, Group, LocationOn, PhoneIphone } from "@mui/icons-material";
import { useStyles } from "./styles";
import WithoutInformation from "./WithoutInformation";
import { Bar } from "../../components/Recharts/Bar";
import { Pie } from "../../components/Recharts/Pie";
import { BarStacked } from "../../components/Recharts/BarStacked";
import { isEmpty } from "lodash";
import { PaperChart } from "../../components/PaperChart";
import { Paper } from "../../components/Paper";
import { useAudience } from "../../hooks/useAudience";

function Overview() {
  const styles = useStyles();

  const { filtroConsulta: filterData } = useAudience();

  const customerTotalizers = useQuery("customerTotalizers", () =>
    listCustomerTotalizers(filterData)
  );

  const totalRegistrations = useQuery("listTotalRegistrations", () =>
    listTotalRegistrations(filterData)
  );

  const overviewDDD = useQuery("listOverviewDDD", () =>
    listOverviewDDD(filterData)
  );

  const overviewGenre = useQuery("listOverviewGenre", () =>
    listOverviewGenre(filterData)
  );

  const overviewRegisterDay = useQuery("listOverviewRegisterDay", () =>
    listOverviewRegisterDay(filterData)
  );

  const overviewRegisterMonth = useQuery("listOverviewRegisterMonth", () =>
    listOverviewRegisterMonth(filterData)
  );

  const overviewAge = useQuery("listOverviewAge", () =>
    listOverviewAge(filterData)
  );

  useEffect(() => {
    if (filterData.changeToRefetch) {
      customerTotalizers.refetch();
      totalRegistrations.refetch();
      overviewDDD.refetch();
      overviewGenre.refetch();
      overviewRegisterDay.refetch();
      overviewRegisterMonth.refetch();
      overviewAge.refetch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData.changeToRefetch]);

  return (
    <Stack spacing={4}>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <Paper
          loading={totalRegistrations.isFetching}
          icon={<Group color="primary" fontSize="large" />}
          label="Cadastros"
          className={styles.paper}
          variant="outlined"
          elevation={0}
          start={0}
          end={Number(totalRegistrations.data || 0)}
        />

        <Paper
          loading={customerTotalizers.isFetching}
          icon={<PhoneIphone color="primary" fontSize="large" />}
          label="Celulares"
          className={styles.paper}
          variant="outlined"
          elevation={0}
          start={0}
          end={customerTotalizers.data?.celular}
        />

        <Paper
          loading={customerTotalizers.isFetching}
          icon={<Email color="primary" fontSize="large" />}
          label="Emails"
          className={styles.paper}
          variant="outlined"
          elevation={0}
          start={0}
          end={customerTotalizers.data?.email}
        />

        <Paper
          loading={customerTotalizers.isFetching}
          icon={<LocationOn color="primary" fontSize="large" />}
          label="Endereços"
          className={styles.paper}
          variant="outlined"
          elevation={0}
          start={0}
          end={customerTotalizers.data?.endereco}
        />
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <PaperChart
          loading={overviewGenre.isFetching}
          label="Gêneros"
          className={styles.paperCharts}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(overviewGenre.data) ? (
            <Pie
              nameKey="SEXO"
              dataKey="QUANTIDADE"
              data={overviewGenre.data}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>

        <PaperChart
          loading={overviewDDD.isFetching}
          label="DDD"
          className={styles.paperCharts}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(overviewDDD.data) ? (
            <Pie nameKey="DDD" dataKey="QUANTIDADE" data={overviewDDD.data} />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>
      </Stack>
      <Stack direction="row" justifyContent="space-between" spacing={2}>
        <PaperChart
          loading={overviewAge.isFetching}
          label="Idade"
          className={styles.paperCharts}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(overviewAge.data) ? (
            <BarStacked
              bars={overviewAge.data?.bars}
              data={overviewAge.data?.data}
              nameKey="FAIXA"
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>
        <PaperChart
          loading={overviewRegisterMonth.isFetching}
          label=" Cadastros por mês"
          className={styles.paperCharts}
          variant="outlined"
          elevation={0}
        >
          {!isEmpty(overviewRegisterMonth.data) ? (
            //@ts-ignore
            <Bar
              barLegend
              xDataKey="DATE"
              barDataKey="QUANTIDADE"
              data={overviewRegisterMonth.data}
            />
          ) : (
            <WithoutInformation />
          )}
        </PaperChart>
      </Stack>
      <PaperChart
        loading={overviewRegisterDay.isFetching}
        label="Cadastros por dia"
        className={styles.paperCreatedDay}
        variant="outlined"
        elevation={0}
      >
        {!isEmpty(overviewRegisterDay.data) ? (
          //@ts-ignore
          <Bar
            barLegend
            xDataKey="DATE"
            barDataKey="QUANTIDADE"
            data={overviewRegisterDay.data}
          />
        ) : (
          <WithoutInformation />
        )}
      </PaperChart>
    </Stack>
  );
}

export default Overview;
